import type { Client, Order, WalletEntry } from './types';

export type PeriodKey='today'|'yesterday'|'7d'|'30d'|'month'|'previousMonth'|'all';

export const periodLabels:Record<PeriodKey,string>={
  today:'Сегодня',yesterday:'Вчера','7d':'Последние 7 дней','30d':'Последние 30 дней',month:'Текущий месяц',previousMonth:'Предыдущий месяц',all:'Всё время',
};

export function getPeriodRange(key:PeriodKey, now=new Date()){
  const end=new Date(now);end.setHours(23,59,59,999);
  const start=new Date(now);start.setHours(0,0,0,0);
  if(key==='yesterday'){start.setDate(start.getDate()-1);end.setDate(end.getDate()-1);end.setHours(23,59,59,999)}
  if(key==='7d')start.setDate(start.getDate()-6);
  if(key==='30d')start.setDate(start.getDate()-29);
  if(key==='month')start.setDate(1);
  if(key==='previousMonth'){start.setMonth(start.getMonth()-1,1);end.setDate(0);end.setHours(23,59,59,999)}
  if(key==='all')start.setFullYear(2000,0,1);
  return {start,end};
}

export function inPeriod(value:string|undefined,key:PeriodKey){
  if(!value)return key==='all';
  const date=new Date(value);if(Number.isNaN(date.getTime()))return key==='all';
  const {start,end}=getPeriodRange(key);return date>=start&&date<=end;
}

export const orderCost=(order:Order)=>Math.max(0,order.cost??Math.round(order.amount*.67));
export const orderPaid=(order:Order)=>Math.max(0,order.paidAmount??(order.payment==='Оплачено'?order.amount:order.payment==='Предоплата'?Math.round(order.amount*.3):0));
export const orderReturn=(order:Order)=>Math.max(0,order.returnedAmount??0);
export const isRecognized=(order:Order)=>order.status==='Выдан';

export function calculateAnalytics(orders:Order[],clients:Client[],entries:WalletEntry[],period:PeriodKey){
  const periodOrders=orders.filter(order=>inPeriod(order.createdAt,period));
  const sales=periodOrders.filter(isRecognized);
  const revenue=sales.reduce((sum,order)=>sum+order.amount-orderReturn(order),0);
  const cost=sales.reduce((sum,order)=>sum+orderCost(order),0);
  const grossProfit=revenue-cost;
  const returns=sales.reduce((sum,order)=>sum+orderReturn(order),0);
  const payments=entries.filter(entry=>entry.amount>0&&inPeriod(entry.createdAt,period)).reduce((sum,entry)=>sum+entry.amount,0);
  const newClients=clients.filter(client=>inPeriod(client.createdAt,period)).length;
  const byClient=new Map<string,{client:Client|undefined;orders:number;revenue:number;cost:number;returns:number;paid:number}>();
  for(const order of sales){const key=order.clientId||order.client;const row=byClient.get(key)??{client:clients.find(client=>client.id===order.clientId||client.name===order.client),orders:0,revenue:0,cost:0,returns:0,paid:0};row.orders+=1;row.revenue+=order.amount-orderReturn(order);row.cost+=orderCost(order);row.returns+=orderReturn(order);row.paid+=orderPaid(order);byClient.set(key,row)}
  return {periodOrders,sales,revenue,cost,grossProfit,margin:revenue?grossProfit/revenue*100:0,returns,payments,newClients,averageCheck:sales.length?revenue/sales.length:0,byClient:[...byClient.values()].sort((a,b)=>b.revenue-a.revenue)};
}

export function dailySeries(orders:Order[],period:PeriodKey,days=14){
  const {end}=getPeriodRange(period);const points:Array<{date:Date;value:number}>=[];
  for(let offset=days-1;offset>=0;offset--){const date=new Date(end);date.setHours(0,0,0,0);date.setDate(date.getDate()-offset);points.push({date,value:0})}
  for(const order of orders.filter(isRecognized)){const date=new Date(order.createdAt||'');if(Number.isNaN(date.getTime()))continue;const point=points.find(item=>item.date.toDateString()===date.toDateString());if(point)point.value+=(order.amount-orderReturn(order))/1_000_000}
  return points;
}

export function downloadCsv(filename:string,headers:string[],rows:Array<Array<string|number>>){
  const escape=(value:string|number)=>`"${String(value).replaceAll('"','""')}"`;
  const csv='\uFEFF'+[headers,...rows].map(row=>row.map(escape).join(';')).join('\r\n');
  const url=URL.createObjectURL(new Blob([csv],{type:'text/csv;charset=utf-8'}));
  const anchor=document.createElement('a');anchor.href=url;anchor.download=filename;anchor.click();URL.revokeObjectURL(url);
}
